import useBoop, { Args, TUseBoop } from "./useBoop"

const useSmallBoopDown = (args?: Args): TUseBoop => useBoop({ y: 3, ...args })

export default useSmallBoopDown
